/* eslint-disable react/prop-types */

import React from "react";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer"; 
import Settings from "../components/Settings";
import { Toaster } from "react-hot-toast";

import styled from "styled-components";

const MainWrapper = styled(Main)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Dashboard = ({ children, title }) => (
  <React.Fragment>
    <Wrapper>
      <MainWrapper>
        <Navbar />
        <Content>
          <h1 style={{ textAlign: "center", marginBottom: "10px" }}>{title}</h1>
          {children}
          <div>
            <Toaster
              toastOptions={{
              duration: 8000 }}/>
            </div>
        </Content>
        <Footer />
      </MainWrapper>
    </Wrapper>
    <Settings />
  </React.Fragment>
);

export default Dashboard;
